/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Plant_Together_TitleInputs */

const en_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant Together with Friends`)
};

const ar_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع مع الأصدقاء`)
};

const de_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinsam mit Freunden pflanzen`)
};

const es_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantar junto con amigos`)
};

const fr_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantez en groupe entre amis`)
};

const it_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta insieme agli amici`)
};

const ja_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`友達と一緒に植える`)
};

const ko_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`친구와 함께 나무를 심어 보세요`)
};

const pt_br_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantio com amigos`)
};

const ru_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сажайте вместе с друзьями`)
};

const th_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้ร่วมกับเพื่อน ๆ`)
};

const tr_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arkadaşlarınla Birlikte Ağaç Dik`)
};

const zh_cn_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`和好友一起种`)
};

const zh_tw_subscription_service_level_compare_plant_together_title = /** @type {(inputs: Subscription_Service_Level_Compare_Plant_Together_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`和好友一起種`)
};

/**
* | output |
* | --- |
* | "Plant Together with Friends" |
*
* @param {Subscription_Service_Level_Compare_Plant_Together_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_plant_together_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Plant_Together_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Plant_Together_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_plant_together_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_plant_together_title(inputs)
	return zh_tw_subscription_service_level_compare_plant_together_title(inputs)
});